import * as React from "react";

function CopyFill(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M7 0C5.897 0 5 .897 5 2v7c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H7zM2 5C.897 5 0 5.897 0 7v7c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-2H9v2H2V7h2V5H2z"
        fill="#415466"
      />
    </svg>
  );
}

const MemoCopyFill = React.memo(CopyFill);
export default MemoCopyFill;
